var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-layout"},[_c('div',{staticClass:"sidebar-layout__sidebar-wrapper"},[_c('admin-sidebar',{attrs:{"items":_vm.sidebar}})],1),_c('div',{staticClass:"sidebar-layout__views-wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }